import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import {
  IntrospectionFragmentMatcher,
  InMemoryCache
} from 'apollo-cache-inmemory'
import { withClientState } from 'apollo-link-state'
import { ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import resolvers from './resolvers'
import Auth from '../config/okta'
import { BASE_URL, OktaConfig } from '../config'
import {
  LO_STO,
  SESH_STO,
  generateSuki64bitID,
  logout,
  HALF_STORY
} from '../lib'
import loSto from '../config/loSto'
import seshSto from '../config/seshSto'
import introspectionQueryResultData from './fragmentTypes.json'
import { halfStory as hs } from '../lib/logging'
import { get } from 'lodash'
import OktaAuth from '@okta/okta-auth-js'

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
})

const cache = new InMemoryCache({ fragmentMatcher })

// config for apollo-link-state
const stateLink = withClientState({
  cache,
  ...resolvers
})

// Consider adding the following and
// calling `client.resetStore` on logout
// const unsubscribe = client.onResetStore(stateLink.writeDefaults)

// instantiate a new client with our custom endpoint
const httpLink = new HttpLink({
  uri: BASE_URL + '/graphql',
  credentials: 'same-origin'
})

// For attaching the access token to every graphql request.
// pattern obtained from: https://github.com/apollographql/apollo-link/tree/master/packages/apollo-link-context
const withToken = setContext(async request => {
  const idToken = await Auth.getIdToken()
  // const sessionId = loSto.get(LO_STO.SESSION_TOKEN)
  let sessionId = loSto.get(LO_STO.SESSION_ID)
  if (!sessionId) {
    const oktaAuth = OktaAuth(OktaConfig.auth)
    const session = await oktaAuth.session.get()
    sessionId = session.id
    loSto.set(LO_STO.SESSION_ID, sessionId)
  }
  const userId = loSto.get(LO_STO.USER_ID)
  const traceId = generateSuki64bitID()
  const org = seshSto.session(SESH_STO.CURRENT_ORGANIZATION)

  let primaryEmr = 'UNKNOWN'
  let secondaryEmr = 'UNKNOWN_EMR'
  if (org) {
    primaryEmr = get(org, 'emr.type')
    secondaryEmr = get(org, 'emr.secondaryType')
  }

  return {
    headers: {
      authorization: idToken,
      'Suki-Session-ID': sessionId,
      'Suki-User-ID': userId,
      'Suki-Trace-ID': traceId,
      'Suki-Role': 'USER',
      'suki-s2-client': 'true',
      'suki-primary-emr': primaryEmr,
      'suki-secondary-emr': secondaryEmr
    }
  }
})

const resetToken = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.info(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    )
  }
  if (networkError && networkError.statusCode === 401) {
    console.info(`[Network error]: ${networkError}`)
    hs.add(HALF_STORY.LOGOUT, `Logging out due to network error: ${networkError}`)
    logout()
  }
})

const client = new ApolloClient({
  cache,
  link: ApolloLink.from([ // order of links is important
    withToken,
    resetToken,
    stateLink,
    httpLink
  ])
})

export default client
